const SVG_NS = 'http://www.w3.org/2000/svg';

/** The svg's height-to-width ratio from its viewBox (or width/height), or null. */
const aspectOf = (svg: Element): number | null => {
  const [, , width, height] = (svg.getAttribute('viewBox') ?? '').trim().split(/[\s,]+/).map(Number);
  if (width > 0 && height > 0) return height / width;
  const w = parseFloat(svg.getAttribute('width') ?? '');
  const h = parseFloat(svg.getAttribute('height') ?? '');
  return w > 0 && h > 0 ? h / w : null;
};

/**
 * The svg as a data: URL an <img> can show, plus its aspect ratio. An <img> reads the svg as standalone XML, so a
 * file that is not (no xmlns, HTML entities such as &nbsp;) is re-read the way a browser reads svg inline in HTML
 * and written back out as XML. Neither parser runs script.
 */
export const svgImage = (svgText: string): { url: string; aspect: number | null } => {
  const xml = new DOMParser().parseFromString(svgText, 'image/svg+xml');
  let svg: Element | null = xml.documentElement;
  let text = svgText;
  if (xml.getElementsByTagName('parsererror').length || svg.namespaceURI !== SVG_NS) {
    svg = new DOMParser().parseFromString(svgText, 'text/html').querySelector('svg');
    if (svg) text = new XMLSerializer().serializeToString(svg);
  }
  return { url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(text)}`, aspect: svg ? aspectOf(svg) : null };
};
